import { render, staticRenderFns } from "./SubscriberUpdateBox.vue?vue&type=template&id=4baed58e"
import script from "./SubscriberUpdateBox.vue?vue&type=script&lang=js"
export * from "./SubscriberUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports